import type { CollapseTransitionTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const collapseTransitionDark: CollapseTransitionTheme = {
  name: 'CollapseTransition',
  common: commonDark,
  self
}

export default collapseTransitionDark
